import styles from './SheetHeader.module.scss';

import React, { AllHTMLAttributes, FC, MouseEventHandler } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { MaterialIcon } from 'components/MaterialIcon/MaterialIcon';
import { TextV2 } from 'components/TextV2/TextV2';
import { Asset } from 'contentful';
import { Image } from 'components/Image/Image';

interface IModalHeader extends AllHTMLAttributes<HTMLElement>, WithTranslation {
  heading?: string;
  customIcon?: Asset;
  onCloseButtonClick?: MouseEventHandler<HTMLButtonElement>;
}

const SheetHeader: FC<IModalHeader> = ({
  heading,
  customIcon,
  onCloseButtonClick,
  children,
  i18n,
  t,
  tReady,
  ...props
}) => (
  <header className={styles.modalHeader} {...props}>
    <div className={styles.modalHeaderTitleAndIconWrapper}>
      {customIcon && (
        <Image src={customIcon?.fields.file.url} className={styles.modalHeaderIcon} isLazyLoad={false} />
      )}
      <TextV2 value={heading} tagName="h4" variant="modern-h4" className={styles.modalHeaderTitle} />
    </div>
    <button className={styles.closeButton} onClick={onCloseButtonClick} title={t('close')}>
      <MaterialIcon icon="clear" />
    </button>
  </header>
);

const Translated = withTranslation()(SheetHeader);
export { Translated as SheetHeader };
